<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <AccountTabs></AccountTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <div class="columns is-mobile is-centered">
            <div class="column is-one-fifth has-text-centered">
                <a @click="save()" class="button is-primary is-fullwidth">
                    <span class="icon">
                        <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-save']"></i>
                    </span>
                </a>
            </div>
        </div>
          <div class="columns is-mobile is-centered">
            <div class="column is-full has-text-centered">
                <div class="field">
                    <div class="control has-icons-left">
                        <input ref="name" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" :placeholder="$t('Name')" v-model="user.name" autocomplete="off" required>
                        <span class="icon is-small is-left">
                            <i class="fa fa-user"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
            <div class="column is-half">
                <div class="control has-icons-left">
                    <div class="select is-fullwidth">
                        <div class="select is-fullwidth">
                            <select ref="callingCode" v-model="user.callingCode" required>
                                <option disabled value="disabled">{{ $t("Country")}}</option>
                                <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                            </select>
                        </div>
                    </div>
                    <div class="icon is-small is-left">
                        <i class="fa fa-globe"></i>
                    </div>
                </div>
            </div>
            <div class="column is-half">
                <div class="field">
                    <div class="control has-icons-left">
                        <input ref="mobile" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="user.mobile" required autocomplete="off" min="0">
                        <span class="icon is-small is-left">
                            <i class="fa fa-phone"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="has-text-centered">{{ $t("ChangeMobile") }}</div>
        <div class="columns is-mobile is-centered">
            <div class="column is-full">
                <div class="field">
                    <div class="control has-icons-left">
                        <input ref="email" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="email" :placeholder="$t('Email')" v-model="user.email" autocomplete="off">
                        <span class="icon is-small is-left">
                            <i class="fa fa-envelope"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
            <div class="column is-full">
                <div class="control has-icons-left">
                    <input class="input" type="text" :value="country" disabled readonly>
                    <span class="icon is-small is-left">
                        <i class="fa fa-globe"></i>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="!hasHousehold" class="column is-full has-text-centered">
            <a @click="$router.push('/account/register-household')" class="has-text-weight-bold">
                <span class="icon">
                    <i class="fa fa-plus-circle"></i>
                </span>
                <span>{{ $t("RegisterMyHousehold") }}</span>
            </a>
        </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import AccountTabs from "@/components/AccountTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "AccountProfile",
  components: {
    Header,
    Modal,
    AccountTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  data () {
    return {
        modal: {
            title: null,
            body: null,
            centerBody: true,
            className: "",
            buttons:
            [
                {id: 0, title: this.$t("OK"), className: "is-primary", click: () => { this.modal.className = ""; }}
            ]
        }
    }
  },
  computed: {
    country: function()
    {
        for(const country of this.countries)
        {
            if(country.countryId == this.user.countryID)
            {
                return country.name;
            }
        }

        return "";
    }
  },
  methods:
  {
    save: async function() {
        if(this.loading)
        {
            return;
        }

        let body;

        if(!this.$refs.name.checkValidity())
        {
            this.$refs.name.reportValidity();
            return;
        }

        if (this.$refs.callingCode.selectedIndex == 0) {
            this.$refs.callingCode.selectedIndex = -1;
        }

        if(!this.$refs.callingCode.checkValidity())
        {
            this.$refs.callingCode.reportValidity();
            return;
        }

        if(!this.$refs.mobile.checkValidity())
        {
            this.$refs.mobile.reportValidity();
            return;
        }

        if(!this.$refs.email.checkValidity())
        {
            this.$refs.email.reportValidity();
            return;
        }

        body =
        {
            name: this.user.name,
            callingCode: this.user.callingCode,
            mobile: this.user.mobile,
            email: this.user.email,
        }

        this.$refs.content.scrollTo(0, 0);

        try
        {
            const response = await this.$http.post(`/User`, body);
            const user = response.data;
            this.user = user;
            this.notification =
            {
                show: true,
                className: "is-success",
                text: this.$t("Updated")
            }
        }

        catch(error)
        {
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    }
  }
};
</script>
